module.exports = __webpack_public_path__ + "img/Logo_Mercado_Link.efad4ed9.png";